export const ListItemTypes = {
  item: "item",
  placeholder: "placeholder",
} as const;
